module.exports = __webpack_public_path__ + "img/porch-swing.229a52a9.webp";